import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "8",
      cy: "8",
      r: "8",
      fill: "#9F8D5E"
    }, null, -1),
    _createElementVNode("path", {
      d: "M9.875 8.625L12.235 10.5917C12.2874 10.6353 12.3542 10.665 12.4269 10.6771C12.4996 10.6891 12.575 10.6829 12.6435 10.6593C12.7119 10.6357 12.7705 10.5956 12.8117 10.5443C12.8529 10.493 12.8749 10.4326 12.875 10.3708L12.875 5.62917C12.8749 5.5674 12.8529 5.50704 12.8117 5.4557C12.7705 5.40436 12.7119 5.36435 12.6435 5.34072C12.575 5.31709 12.4996 5.3109 12.4269 5.32293C12.3542 5.33497 12.2874 5.36469 12.235 5.40834L9.875 7.375M4.25 5.1875L8.75 5.1875C9.04837 5.1875 9.33452 5.28627 9.5455 5.46209C9.75647 5.6379 9.875 5.87636 9.875 6.125L9.875 9.875C9.875 10.1236 9.75647 10.3621 9.5455 10.5379C9.33452 10.7137 9.04837 10.8125 8.75 10.8125L4.25 10.8125C3.95163 10.8125 3.66548 10.7137 3.4545 10.5379C3.24353 10.3621 3.125 10.1236 3.125 9.875L3.125 6.125C3.125 5.87636 3.24353 5.6379 3.45451 5.46209C3.66548 5.28627 3.95163 5.1875 4.25 5.1875Z",
      stroke: "white",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }